export const toneFor = (score) => {
  if (score >= 60) return { key: "hopeful", label: "Positive", hex: "#10b981", soft: "#d1fae5", pill: "bg-emerald-50 text-emerald-800 border-emerald-200" };
  if (score >= 40) return { key: "balanced", label: "Neutral", hex: "#f59e0b", soft: "#fef3c7", pill: "bg-amber-50 text-amber-800 border-amber-200" };
  return { key: "strained", label: "Concern", hex: "#fb7185", soft: "#ffe4e6", pill: "bg-rose-50 text-rose-800 border-rose-200" };
};

export const PROVINCE_NAMES = {
  BC: "British Columbia", AB: "Alberta", SK: "Saskatchewan", MB: "Manitoba", ON: "Ontario", QC: "Quebec",
  NB: "New Brunswick", NS: "Nova Scotia", PE: "Prince Edward Island", NL: "Newfoundland and Labrador",
  YT: "Yukon", NT: "Northwest Territories", NU: "Nunavut",
};

export const timeAgo = (iso) => {
  const mins = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 60) return `${mins}m ago`;
  const h = Math.round(mins / 60);
  return h < 48 ? `${h}h ago` : `${Math.round(h / 24)}d ago`;
};
